export const SET_SIGNIFYD_SESSION_ID = 'SET_SIGNIFYD_SESSION_ID';
